var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "demo-wrap theme-light" }, [
    _c(
      "div",
      {
        staticStyle: {
          "padding-right": "60px",
          width: "100%",
          height: "100%",
          "overflow-y": "auto",
          "box-sizing": "border-box",
          display: "flex",
        },
      },
      [
        _c("iframe", {
          ref: "iframe",
          staticStyle: { width: "100%", height: "100%", border: "0" },
          attrs: {
            src: _vm.url,
            allow: "camera *;microphone;display-capture;clipboard-write;",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "otm-frame-container",
        staticClass: "frame-active frame-toggle open",
        attrs: { id: "otm-container-monitoring" },
      },
      [
        _c("div", { staticClass: "otm-wrap monitoring" }, [
          _c("nav", { staticClass: "sidebar" }, [
            _c("ul", { staticClass: "menu-ul" }, [
              _c("li", { attrs: { id: "menu-toggle" } }, [
                _c(
                  "a",
                  {
                    staticClass: "menu menu-toggle",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleMenu.apply(null, arguments)
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("monitoring.menu.hide")))])]
                ),
              ]),
              _vm._v(" "),
              _c("li", { ref: "menu-front", attrs: { id: "menu-front" } }, [
                _c(
                  "a",
                  {
                    staticClass: "menu menu-front",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleMenu.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("monitoring.menu.frontal"))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { ref: "menu-chat", attrs: { id: "menu-chat" } }, [
                _c("a", {
                  staticClass: "menu menu-chat",
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleMenu.apply(null, arguments)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "monitoring-inner" }, [
            _c("div", { staticClass: "otm-header" }, [
              _c("h1", { staticClass: "h1-text" }, [
                _vm._v(_vm._s(_vm.$t("demo.demoExamRoom.monitoring"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "otm-body" }, [
              _c("div", { staticClass: "otm-body-inner" }, [
                _c("div", { staticClass: "connection-wrap section" }, [
                  _c(
                    "div",
                    {
                      ref: "item-front",
                      staticClass: "item item-front line-bottom connected",
                    },
                    [
                      _c("div", { staticClass: "tit-box between" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("demo.demoExamRoom.front"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "icon icon-text ing-rec" }, [
                          _vm._v("REC"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "connection-box" }, [
                        _c("div", { staticClass: "after" }, [
                          _c("div", { staticClass: "video-box" }, [
                            _c("canvas", {
                              ref: "canvas",
                              staticStyle: { display: "none" },
                            }),
                            _vm._v(" "),
                            _c("video", {
                              ref: "video_self",
                              attrs: {
                                autoplay: "",
                                width: "100%",
                                height: "100%",
                              },
                              on: { play: _vm.playVideo },
                            }),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-wrap" }, [
                        _vm.logDetectList.length === 0
                          ? _c("div", { staticClass: "no-data" }, [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", { staticClass: "text" }, [
                                _vm._v(_vm._s(_vm.$t("demo.demoExamRoom.ai"))),
                              ]),
                            ])
                          : _c(
                              "div",
                              {
                                ref: "eventList",
                                staticClass:
                                  "list-group history-list list-group-flush",
                              },
                              _vm._l(_vm.logDetectList, function (log, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "list-group-item",
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-code status-dot col-auto",
                                          class: _vm.getStatusClass(log.status),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.statusName(log.status))
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "info-date col-auto" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("yearToSecond")(
                                                  log.created
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "item-chat",
                    staticClass: "chat-wrap section line-bottom new-chat",
                  },
                  [
                    _c("div", { staticClass: "tit-box" }, [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.$t("demo.demoExamRoom.chatting"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chat-inner" }, [
                      _c("div", { staticClass: "inner" }, [
                        _c(
                          "div",
                          { staticClass: "chat-cant" },
                          [
                            _c("i18n", {
                              staticClass: "inner-text",
                              attrs: {
                                tag: "div",
                                path: "demo.demoExamRoom.noChat",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "br",
                                  fn: function () {
                                    return [_c("br")]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "chat-messages" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "chat-input-box" }, [
                          _c("input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("demo.demoExamRoom.msg"),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-send",
                              attrs: { type: "button" },
                            },
                            [
                              _c("span", { staticClass: "blind" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("demo.demoExamRoom.send"))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }